import { trans } from "@mongez/localization";
import { ShopProduct } from "core/catalog";
import { BaseLink } from "~/design-system/components";
import { Price } from "~/modules/our-cakes/components/Price";
import { searchAtom } from "~/modules/shared/atoms";
import { URLS } from "~/shared/urls";
import { Image } from "../../../Image";
import { NoResults } from "./NoResult";

type ProductsSearchResultProps = {
  loading: boolean;
  products: ShopProduct[];
};

export function ProductsSearchResult({
  loading,
  products,
}: ProductsSearchResultProps) {
  if (loading)
    return (
      <div className="flex h-[300px] flex-col items-center justify-center text-center text-xl font-bold capitalize">
        <p className="text-center">{trans("loading")}</p>
      </div>
    );

  if (products.length == 0) return <NoResults message="No results found" />;

  return (
    <ul className="mt-4 flex w-full flex-col gap-2">
      {products.map((product) => (
        <li key={product.id} className="w-full">
          <BaseLink
            to={URLS.ourCakes.view(product)}
            onClick={searchAtom.close}
            className="group hover:bg-primary-200 flex w-full items-center justify-between gap-3 rounded-xl p-2 duration-300"
          >
            <div className="flex items-center gap-2">
              <img
                src={product.primaryImage?.medium?.url}
                alt={product.name}
                width={40}
                height={40}
                className="size-10 rounded"
              />
              <div className="flex flex-col gap-1">
                <span className="font-semibold duration-300 group-hover:underline">
                  {product.name}
                </span>
                <Price
                  classes={{
                    price: "text-sm",
                    salePrice: "text-sm",
                  }}
                  originalPrice={product.price.original}
                  salePrice={product.price.sale}
                />
              </div>
            </div>
          </BaseLink>
        </li>
      ))}
    </ul>
  );
}
